import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../contexts/AuthContext';
import './Auth.css';

function ForgotPassword() {
  const { t } = useTranslation();
  const { forgotPassword } = useContext(AuthContext);
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [resetUrl, setResetUrl] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setResetUrl('');

    try {
      const response = await forgotPassword(email);
      setSuccess(response.message || t('auth.resetRequestSent'));
      if (response.reset_url) {
        setResetUrl(response.reset_url);
      }
    } catch (err) {
      setError(err.response?.data?.error || t('auth.resetRequestFailed'));
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>{t('auth.forgotPasswordTitle')}</h2>
        {error && <div className="error-message">{error}</div>}
        {success && <div className="success-message">{success}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>{t('auth.email')}</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary">{t('auth.sendResetLink')}</button>
        </form>
        {resetUrl && (
          <p className="auth-link">
            <a href={resetUrl}>{t('auth.openResetLink')}</a>
          </p>
        )}
        <p className="auth-link">
          <Link to="/login">{t('auth.backToLogin')}</Link>
        </p>
      </div>
    </div>
  );
}

export default ForgotPassword;
